/** Tipos e rótulos para correções e histórico do orçado (solis_orcamento). */

import type { AuditoriaRowBase, CorrigirResult } from "@/lib/auditoriaCorrecao";

export const ORC_TABLE = "solis_orcamento" as const;
export const ORC_AUDIT_TABLE = "solis_orcamento_auditoria" as const;
export const ORC_CORRIGIR_RPC = "solis_orcamento_corrigir" as const;

export type OrcPatchableField =
  | "mes"
  | "mes_competencia"
  | "data"
  | "valor_imposto"
  | "valor"
  | "historico"
  | "centro_resultado"
  | "tipo_receita_despesa"
  | "classificacao_receita_despesa"
  | "descricao_receita_despesa"
  | "cliente_fornecedor"
  | "pti"
  | "tipo_td"
  | "classificacao_td"
  | "area"
  | "sub_area";

export const ORC_FIELD_LABELS: Record<OrcPatchableField, string> = {
  mes: "Mês",
  mes_competencia: "Mês competência",
  data: "Data",
  valor_imposto: "Valor imposto",
  valor: "Valor (R$)",
  historico: "Histórico",
  centro_resultado: "Centro de resultado",
  tipo_receita_despesa: "Tipo receita/despesa",
  classificacao_receita_despesa: "Classificação receita/despesa",
  descricao_receita_despesa: "Descrição receita/despesa",
  cliente_fornecedor: "Cliente/fornecedor",
  pti: "P/T.I.",
  tipo_td: "Tipo TD",
  classificacao_td: "Classificação TD",
  area: "Área",
  sub_area: "Subárea",
};

export const ORC_CORRECAO_FIELDS_PRIMARY: OrcPatchableField[] = [
  "valor",
  "centro_resultado",
  "area",
  "sub_area",
  "tipo_receita_despesa",
  "classificacao_receita_despesa",
  "descricao_receita_despesa",
  "data",
];

export const ORC_CORRECAO_FIELDS_SECONDARY: OrcPatchableField[] = [
  "mes",
  "mes_competencia",
  "valor_imposto",
  "historico",
  "cliente_fornecedor",
  "pti",
  "tipo_td",
  "classificacao_td",
];

export interface OrcAuditoriaRow extends AuditoriaRowBase {
  mes_ref: string | null;
}

export type OrcCorrigirResult = CorrigirResult;

export { AUDITORIA_CANAIS_SOLICITACAO as ORC_CANAIS_SOLICITACAO } from "@/lib/auditoriaCorrecao";
export {
  labelCanalSolicitacao,
  formatAuditValue as formatOrcValue,
  eventoBadgeVariant,
} from "@/lib/auditoriaCorrecao";
